
/* Using a self-executing anonymous function - (function(){})(); - so that all variables and functions defined within
arenâ€™t available to the outside world. */
(function(){

  console.log('starting presale.js (aka crowdfunder) (from script-tag)')

  if(window.Crowdfunder){
    console.log('Crowdfunder is already defined. Exiting!!! (from script-tag)');
    return;
  }

  var Presale = Presale || {};

  // The v2 "server rendered" widnget that just needs augmented after page load
  Presale.widgetSelector = ".crowdfunder-widget";

  Presale.setScriptBaseUrl = function(){
    var parts = document.querySelector('script[src*="presale.js"]').getAttribute('src').split('/');
    parts.pop();
    parts.pop();
    Presale.scriptBaseUrl = parts.join('/');
    //console.log('Presale.scriptBaseUrl', Presale.scriptBaseUrl);
  }

  Presale.init = function(){

    Presale.setScriptBaseUrl();

    /* This is where we kick off the v2 widget. */
    if( document.querySelectorAll(Presale.widgetSelector).length > 0 ){
      //console.log('we have widgets');
      document.querySelectorAll(Presale.widgetSelector).forEach(function(widgetDiv, i){
        //console.log('handling widget', i, widgetDiv);
        Presale.widgetHandler(widgetDiv);
      });
    }

    // We do this so that external scripts can get a hold of our object in case they need to fire
    // some of our methods. Like for single-page-apps that don't have an on-load event.
    window.Crowdfunder = Presale;
  }

  Presale.widgetHandler = function(widgetDiv){
    //console.log('in widgetHandler', widgetDiv);
    var end_time = widgetDiv.querySelector('.cf-time-left').dataset.endTime;
    //console.log("end_time = ", end_time);
    end_time = end_time * 1000; // turn seconds since epoch into milliseconds since epoch
    var cfTimeLeft = widgetDiv.querySelector('.cf-time-left');
    // NOTE : For these next two we also check a fallback value that will be in place for people
    // who still have an older version of the snippet installed. We refactored these to be better
    // named, but we're kind of trapped by the past now...
    var hide_atc_button_at_end = cfTimeLeft.dataset.hideAtcButtonAtEnd || cfTimeLeft.dataset.hideBuyButtonAtEnd || 'no';
    var hide_atc_button_when_funded = cfTimeLeft.dataset.hideAtcButtonWhenFunded || cfTimeLeft.dataset.hideBuyButtonWhenFunded || 'no';
    // End legacy handling
    var add_to_cart_button_selector = cfTimeLeft.dataset.addToCartButtonSelector;
    var product_id = cfTimeLeft.dataset.productId;
    var percent_pre_sold = cfTimeLeft.dataset.percentPreSold;
    var replace_add_to_cart_text = cfTimeLeft.dataset.replaceAddToCartText || 'no';
    var add_to_cart_replacement_text = cfTimeLeft.dataset.addToCartReplacementText;
    var add_to_cart_text_selector = cfTimeLeft.dataset.addToCartTextSelector;
    var data = {
      end_time: end_time,
      add_to_cart_button_selector: add_to_cart_button_selector,
      hide_atc_button_at_end: hide_atc_button_at_end,
      hide_atc_button_when_funded: hide_atc_button_when_funded,
      product_id: product_id,
      percent_pre_sold: percent_pre_sold,
      replace_add_to_cart_text: replace_add_to_cart_text,
      add_to_cart_replacement_text: add_to_cart_replacement_text,
      add_to_cart_text_selector: add_to_cart_text_selector
    };
    //console.log(data);
    Presale.adjustAddToCartButton(widgetDiv, data);
    Presale.adjustTimeLeft(widgetDiv, data);
  }

  Presale.formatTimeLeft = function(duration, expiredText, placeholderDiv){
    var timeLeftDiv = placeholderDiv.querySelector('.cf-time-left');
    diffTime = duration.asMilliseconds;
    //console.log('duration = ', duration);
    var years = duration.years,
        months = duration.months,
        days = duration.days,
        hrs = duration.hours,
        mins = duration.minutes,
        secs = duration.seconds;

    if(diffTime < 0){
      var formattedExpiredText = expiredText || "No more time";
      return formattedExpiredText;
    }

    var diffString =  "";

    if(years > 0){
      diffString += years + ' ' + Presale.pluralizedTime('Year', years, timeLeftDiv) + ' ';
    }
    if(months > 0){
      diffString += months + ' ' + Presale.pluralizedTime('Month', months, timeLeftDiv) + ' ';
    }
    if(days > 0){
      diffString += days + ' ' + Presale.pluralizedTime('Day', days, timeLeftDiv) + ' ';
    }

    if(years == 0 && months == 0 && days == 0){
      if(hrs > 0){
        diffString += hrs + ' ' + (timeLeftDiv.dataset.hourAbbreviationText || 'h') + ' ';
      }
      if(mins > 0){
        diffString += mins + ' ' + (timeLeftDiv.dataset.minuteAbbreviationText || 'm') + ' ';
      }
      if(hrs > 0 || mins > 0 || secs > 0){
        diffString += secs + ' ' + (timeLeftDiv.dataset.secondAbbreviationText || 's') + ' ';
      }
      //diffString += hrs + ' hrs ' + mins + ' mins ' + secs + ' sec';
    }
    return diffString;
  }

  Presale.pluralizedTime = function(timeName, value, timeLeftDiv){
    var userSetting = value > 1 ? timeLeftDiv.dataset['plural'+timeName+'Text'] : timeLeftDiv.dataset['singular'+timeName+'Text'];
    return userSetting || timeName + (value > 1 ? 's' : '');
  }


  Presale.calcTimeLeftDuration = function(data){
    var endTime = new Date(data.end_time);
    var now = new Date();
    var diff = endTime - now;
    //console.log('diff = ', diff);
    var asMilliseconds = diff;
    var years = Math.floor(diff / 1000 / 60 / 60 / 24 / 365);
    diff = diff - (years * 1000 * 60 * 60 * 24 * 365);
    var months = Math.floor(diff / 1000 / 60 / 60 / 24 / 30);
    diff = diff - (months * 1000 * 60 * 60 * 24 * 30);
    var days = Math.floor(diff / 1000 / 60 / 60 / 24 );
    diff = diff - (days * 1000 * 60 * 60 * 24);
    var hours = Math.floor(diff / 1000 / 60 / 60 );
    diff = diff - (hours * 1000 * 60 * 60 );
    var minutes = Math.floor(diff / 1000 / 60 );
    diff = diff - (minutes * 1000 * 60 );
    var seconds = Math.floor(diff / 1000 );


    var duration = {
      years, months, days, hours, minutes, seconds, asMilliseconds
    }
    //console.log('duration = ', duration);
    return duration;
  }

  Presale.adjustAddToCartButton = function(placeholderDiv, data){
    //console.log('adjustAddToCartButton', data);
    if(data.replace_add_to_cart_text == 'yes' &&
       data.add_to_cart_replacement_text && data.add_to_cart_replacement_text != '' &&
       data.add_to_cart_text_selector && data.add_to_cart_text_selector != ''
    ){
      // Here we try to find a "compound taret" by using the product id to more specifically select
      // the particular add-to-cart button that we need to hide. The prevents "simple widets" that
      // happen to be shown on a product page from hosing the add-to-cart button of the main product.
      // If we can't find a compound target we fall back to brute-force hiding their add-to-cart selector.
      var cartSelector = data.add_to_cart_text_selector;
      var productId = data.product_id;
      var compoundSelector = "#product_form_" + productId + " " + cartSelector;
      compoundSelector += ', form[data-product-id="'+ productId +'"] ' + cartSelector;
      var target = document.querySelectorAll(compoundSelector);
      //console.log('compoundSelector', compoundSelector, target);
      if(target.length == 0){
        target = document.querySelectorAll(cartSelector);
        //console.log('cartSelector', cartSelector, target);
      }
      if(target.length > 0){
        target[0].textContent = data.add_to_cart_replacement_text;
      }
    }

  }

  Presale.adjustTimeLeft = function(placeholderDiv, data){
    var duration = this.calcTimeLeftDuration(data);
    var expiredText = placeholderDiv.querySelector('.cf-time-left').dataset.expiredText; // v2
    var timeLeft = this.formatTimeLeft(duration, expiredText, placeholderDiv);
    var selector = data.add_to_cart_button_selector;
    var product_id = data.product_id;
    var percent_pre_sold = data.percent_pre_sold;
    placeholderDiv.querySelector('.cf-time-left').textContent = timeLeft; // v2
    if(duration.asMilliseconds > 0){
      if(percent_pre_sold >= 100 && data.hide_atc_button_when_funded == 'yes'){
        Presale.hideCartButton(selector, product_id);
      }else{
        // TODO: Currently this means that we don't live update the time left after a campaign has been fully funded and the
        // shop has configured the campaign to hide the ATC button. Maybe this should go outside the else? Just documenting
        // for now since I discovered this during gem updates and don't want to mix stuff together.
        setTimeout(Presale.adjustTimeLeft.bind(this, placeholderDiv, data), 1000);
      }
    }else if( data.hide_atc_button_at_end == 'yes' || (data.hide_atc_button_at_end == 'if_not_funded' && data.percent_pre_sold < 100) ){
      Presale.hideCartButton(selector, product_id);
    }
  }

  Presale.hideCartButton = function(cartSelector, productId){
    // Here we try to find a "compound taret" by using the product id to more specifically select
    // the particular add-to-cart button that we need to hide. The prevents "simple widets" that
    // happen to be shown on a product page from hosing the add-to-cart button of the main product.
    // If we can't find a compound target we fall back to brute-force hiding their add-to-cart selector.
    var compoundSelector = "#product_form_" + productId + " " + cartSelector;
    compoundSelector += ', form[data-product-id="'+ productId +'"] ' + cartSelector;
    var compoundTarget = document.querySelectorAll(compoundSelector);
    if(compoundTarget.length > 0){
      compoundTarget.forEach(function(targetDiv){
        targetDiv.style.display = 'none';
      });
    }else{
      document.querySelectorAll(cartSelector).forEach(function(targetDiv){
        targetDiv.style.display = 'none';
      })
    }
  }

  Presale.init();

})();